import { useEffect, useLayoutEffect, useRef, useState } from "react";
import * as React from "react";
import { RootProvider } from "./context/RootProvider";
import { Routes } from "./components/Routes";
import { useRouter } from "./context/Router";
import "./styles/general.css";
import { getRenderResolution } from "./utils/RenderResolution";
var DESIGN_W = 1920;
var DESIGN_H = 1080;
var SAFE_INSET = 0.03;
// Player must be true full screen: no safe-area inset, so the video fills the
// panel edge-to-edge (scale === 1 on a 1080p screen). Every other route keeps
// the 3% overscan-safe inset.
var PLAYER_SAFE_INSET = 0;
var PLAYER_ROUTES = ["watch"];
// Derive the safe box + scale from CSS pixels (innerWidth/Height), not
// DPR-scaled px, so DPR>1 panels still downscale correctly.
var computeDims = function (inset) {
    var res = getRenderResolution();
    var insetX = Math.round(res.innerWidth * inset);
    var insetY = Math.round(res.innerHeight * inset);
    var safeW = res.innerWidth - insetX * 2;
    var safeH = res.innerHeight - insetY * 2;
    var scale = Math.min(safeW / DESIGN_W, safeH / DESIGN_H, 1);
    var tier = res.innerWidth * res.innerHeight < 1.5e6 ? "720p" : "1080p";
    return { insetX: insetX, insetY: insetY, safeW: safeW, safeH: safeH, scale: scale, tier: tier };
};
function SafeFrame() {
    var route = useRouter().route;
    var isPlayer = PLAYER_ROUTES.includes(route);
    var _a = useState("1080p"), tier = _a[0], setTier = _a[1];
    var frameRef = useRef(null);
    var stageRef = useRef(null);
    useLayoutEffect(function () {
        var apply = function () {
            var d = computeDims(isPlayer ? PLAYER_SAFE_INSET : SAFE_INSET);
            setTier(d.tier);
            var frame = frameRef.current;
            if (frame) {
                frame.style.left = d.insetX + "px";
                frame.style.top = d.insetY + "px";
                frame.style.width = d.safeW + "px";
                frame.style.height = d.safeH + "px";
            }
            var stage = stageRef.current;
            if (stage) {
                stage.style.transform = "scale(" + d.scale + ")";
            }
        };
        apply();
        var timeout;
        var handleResize = function () {
            clearTimeout(timeout);
            timeout = window.setTimeout(apply, 50);
        };
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
            clearTimeout(timeout);
        };
    }, [isPlayer]);
    return (React.createElement("div", { ref: frameRef, className: "safe-frame" },
        React.createElement("div", { ref: stageRef, className: "fullscreen-container " + (tier === "720p" ? "compact" : "full") },
            React.createElement(Routes, null))));
}
export default function App() {
    useEffect(function () {
        var loader = document.getElementById("app-loader");
        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader);
        }
    }, []);
    return (React.createElement(RootProvider, null,
        React.createElement(SafeFrame, null)));
}



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 86
// module chunks = 1